import { ReactElement, useEffect, useState } from 'react'

import { FullPageSpinner } from '@percent/workplace-giving/common/components/FullPageSpinner/FullPageSpinner'
import { usePostHogFeatureFlag } from '@percent/workplace-giving/common/hooks/usePostHogFeatureFlag/usePostHogFeatureFlag'
import { POSTHOG_FEATURE_FLAGS } from '@percent/workplace-giving/common/hooks/usePostHogFeatureFlag/posthogFeatureFlags'
import i18n from '@percent/workplace-giving/i18n/config'
import { checkLocaleAvailability } from '@percent/workplace-giving/translations/getUserLanguage/getUserLanguage'
import {
  getBaseSupportedAppLocales,
  getExtendedSupportedAppLocales
} from '@percent/workplace-giving/translations/supportedLocales'

const DEFAULT_LANGUAGE = 'en-US'

export function LanguageInitializer({ children }: Readonly<{ children: ReactElement }>) {
  const extendSupportedAppLocales = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.WPG_EXTEND_SUPPORTED_APP_LOCALES)
  const [isLanguageLoading, setIsLanguageLoading] = useState(true)

  useEffect(() => {
    const setLanguage = async () => {
      let languageCode = DEFAULT_LANGUAGE
      const navigatorLang = navigator.language
      const supportedAppLocales = extendSupportedAppLocales
        ? getExtendedSupportedAppLocales()
        : getBaseSupportedAppLocales()

      if (navigatorLang) {
        const available = checkLocaleAvailability(navigatorLang, supportedAppLocales)

        if (available.supported) {
          languageCode = available.code
        }
      }

      await i18n.changeLanguage(languageCode)
      setIsLanguageLoading(false)
    }

    setLanguage()
  }, [extendSupportedAppLocales])

  if (isLanguageLoading) {
    return <FullPageSpinner />
  }

  return children
}
